import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { theme as newTheme } from 'styles/theme/hav-theme'
import { CardProps } from '.'

type CardStyledProps = Pick<CardProps, 'textColor' | 'titleColor'>

function title(titleColor?: 'secondary' | 'black') {
  if (titleColor === 'secondary') {
    return newTheme.colors.secondary
  }
  if (titleColor === 'black') {
    return newTheme.colors.neutral.black
  }
}
export const CardStyled = styled('div')<CardStyledProps>`
  display: grid;
  background: ${newTheme.colors.neutral.white};
  width: 100%;
  padding: ${newTheme.spacing.xm};
  border-radius: ${newTheme.shapes.borderRadius.md};
  margin-bottom: ${newTheme.spacing.lg};
  h3 {
    margin: 0 0 ${newTheme.spacing.md} 0;
    color: ${({ titleColor }) => title(titleColor)};
    font-family: ${newTheme.typography.family.bold};
    font-weight: ${newTheme.typography.weight.lg};
    font-size: ${newTheme.typography.sizes['2md']};

    ${({ textColor }) =>
      textColor &&
      css`
        color: ${newTheme.colors.neutral.high};
      `}
  }
`
